import { render, staticRenderFns } from "./DataAnalysisTablesEditPage.vue?vue&type=template&id=739c8c4d"
import script from "./DataAnalysisTablesEditPage.vue?vue&type=script&lang=js"
export * from "./DataAnalysisTablesEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports